import './Button.css';

/**
 * #124 — Botão canônico. Mínimo viável (cobre 80%):
 *  - variant: 'primary' (gradiente verde) | 'secondary' (neutro) | 'danger' (destrutivo)
 *  - size: 'md' (default) | 'sm'
 *  - icon?: nome do Material Symbol (ex: 'add', 'download', 'delete')
 *  + props nativos (onClick, type, disabled, ...).
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  icon,
  children,
  className = '',
  ...rest
}) {
  const cls = `ui-btn ui-btn--${variant} ui-btn--${size}${className ? ' ' + className : ''}`;
  return (
    <button className={cls} {...rest}>
      {icon && <span className="material-symbols-outlined ui-btn__icon">{icon}</span>}
      {children != null && <span>{children}</span>}
    </button>
  );
}
